import { NavLink, Outlet } from "react-router-dom";
import { RefreshCw, FileText, LogOut, Database, KeyRound, BellRing, Users, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { SyncNowButton } from "@/components/SyncNowButton";

const NAV = [
  { to: "/sync-reports", label: "Sync Reports", icon: RefreshCw, id: "sidebar-nav-sync-reports" },
  { to: "/documents", label: "S3 Documents", icon: FileText, id: "sidebar-nav-documents" },
  { to: "/keys", label: "API Keys", icon: KeyRound, id: "sidebar-nav-api-keys" },
  { to: "/alerts", label: "Sync Alerts", icon: BellRing, id: "sidebar-nav-alerts" },
  { to: "/admins", label: "Admin Access", icon: Users, id: "sidebar-nav-admins" },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex">
      <aside className="hidden md:flex w-60 shrink-0 flex-col border-r border-slate-800 bg-[#0B1120] sticky top-0 h-screen">
        <div className="px-5 h-16 flex items-center gap-2 border-b border-slate-800">
          <Database className="h-5 w-5 text-indigo-400" />
          <span className="font-heading font-semibold tracking-tight leading-tight text-sm">Prime Rural docs Chatbot</span>
        </div>
        <nav className="p-3 space-y-1 flex-1">
          {NAV.map(({ to, label, icon: Icon, id }) => (
            <NavLink key={to} to={to} data-testid={id}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-indigo-500/15 text-indigo-300 border border-indigo-500/30" : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/60 border border-transparent"}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
          <a href={`${process.env.REACT_APP_BACKEND_URL}/api/docs`} target="_blank" rel="noreferrer" data-testid="sidebar-api-docs-link"
            className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-slate-400 hover:text-slate-100 hover:bg-slate-800/60 border border-transparent transition-colors">
            <BookOpen className="h-4 w-4" /> API Docs ↗
          </a>
        </nav>
        <p className="p-5 font-mono text-[10px] uppercase tracking-wider text-slate-600">Dhwani RIS · Internal</p>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="h-16 border-b border-slate-800 flex items-center justify-between gap-3 px-4 sm:px-8 bg-[#080C14]/80 backdrop-blur-xl sticky top-0 z-20">
          <nav className="flex md:hidden gap-1">
            {NAV.map(({ to, icon: Icon, id }) => (
              <NavLink key={to} to={to} data-testid={`${id}-mobile`} className={({ isActive }) => `p-2 rounded-md ${isActive ? "text-indigo-300 bg-indigo-500/15" : "text-slate-400"}`}><Icon className="h-4 w-4" /></NavLink>
            ))}
          </nav>
          <div className="flex-1" />
          <span data-testid="header-user-email-badge" className="hidden sm:inline font-mono text-xs text-slate-400 border border-slate-700 rounded px-2 py-1 truncate max-w-[220px]">{user?.email}</span>
          <SyncNowButton />
          <Button data-testid="header-logout-button" variant="ghost" size="icon" onClick={logout} className="text-slate-400 hover:text-white hover:bg-slate-800"><LogOut className="h-4 w-4" /></Button>
        </header>
        <main className="p-4 sm:p-8 lg:p-10 max-w-7xl"><Outlet /></main>
      </div>
    </div>
  );
};
